import React, { useEffect, useState,useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { injectModels } from "../redux/injectModels";
import { routes } from "../constants/routes";
import { handleConsoleError } from "../utils/common-methods";
import ReCAPTCHA from "react-google-recaptcha";
import { VerifyCaptcha } from "../services/InquiryService";
import { GlobalSettingService } from "../services";
import { globalConstant } from "../constants/globalConstant";



function AdminLogin(props) {
   const recaptchaRef = useRef(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [passError, setPassError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
      const [token, setToken] = useState(null);
      const [captchaError, setCaptchaError] = useState("");
        const [captchaKey, setCaptchaKey] = useState("");

  const navigate = useNavigate();

    const getCaptchaDetails = async () => {
      try {
        const res = await GlobalSettingService.getRecaptchaDetails();
        if (res?.isSuccess && res?.data) {
          setCaptchaKey(GlobalSettingService.decrypt(res?.data?.keyValue));
        }
      } catch (error) {
        const message= handleConsoleError(error);
        toast.error(error?.message|| message);
      }
    };

  useEffect(() => {
    getCaptchaDetails();
    let email = localStorage.getItem("RememberMeEmail");
    let password = localStorage.getItem("Password");
    const id = localStorage.getItem("access_token"); //localStorage.getItem("UserId");
    if (email != null && password != null) {
      setEmail(email);
      setPassword(password);
      setRememberMe(true);
    }
    if (id != null) {
      navigate(routes.ADMIN_DASHBOARD);
    } else {
      navigate(routes.ADMIN_LOGIN);
    }
  }, []);

  const handleEmailChange = (e) => {
    e.preventDefault();
    const val = e.target?.value?.trim();
    if (val === "") {
      setEmailError("Email is required");
    } else if (!globalConstant.emailRegex.test(val)) {
      setEmailError("Please enter a valid email");
    } else {
      setEmailError("");
    }

    setEmail(val);
  };

  const handlePasswordChange = (e) => {
    const val = e.target?.value;
    if (val.trim() === "") {
      setPassError("Password is required");
    } else {
      setPassError("");
    }
    setPassword(val);
  };

  const handleRememberMeChange = (e) => {
    setRememberMe(e.target?.checked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  try {
        if (!token) {
            setCaptchaError("Captcha is required.");
            return;
          }
           setCaptchaError("");
              props.application.setLoading(true);
             
                const responseReCaptcha = await VerifyCaptcha( {
              captchaToken: token
            });
            
    props.application.setLoading(true, "Login!");

    let valid = true;

    if (password === "") {
      setPassError("Password is required");
      valid = false;
    } else {
      setPassError("");
    }

    if (email.trim() === "") {
      setEmailError("Email is required");
      valid = false;
    } else if (!globalConstant.emailRegex.test(email)) {
      setEmailError("Please enter a valid email");
      valid = false;
    } else {
      setEmailError("");
    }

    if (!valid) {
      props.application.setLoading(false, "");
      return;
    } else {
      const data = {
        username: email.trim(),
        password: password,
      };
    
        props.application.setLoading(true);
        const res = await props.auth.userLoginAdmin(data);
        if (res?.isSuccess) {
          props.application.setLoading(false);
          if (rememberMe) {
            localStorage.setItem("RememberMeEmail", email);
            localStorage.setItem("Password", password);
          } else {
            localStorage.removeItem("RememberMeEmail");
            localStorage.removeItem("Password");
          }

          navigate(routes.ADMIN_DASHBOARD);
          setError("");
        } else {
          props.application.setLoading(false);
          setError(res?.message||res?.Errors?.[0]?.Message);
          localStorage.clear();
         toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
         recaptchaRef.current?.reset();
         setToken(null);
          return;
        }
     
    }
     } catch (err) {       
        props.application.setLoading(false);
        const message=handleConsoleError(err);
        setError(err?.messgae);
        toast.error(err?.message || message);
          recaptchaRef.current?.reset();
    setToken(null);
      }
  };

  const togglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  return (
    <React.Fragment>
      <section className="loginswallow-dashboard">
        <div
          className="loginswallow-dashboard2"
          style={{ margin: "100px auto" }}
        >
          <form onSubmit={handleSubmit}>
            <div className="main-admin-login">
              <img
                className="swallow-logo-login header"
                src="/assets/images/logo-swallow.jpg"
                alt=""
              />
            </div>
            <p style={{ textAlign: "center" }}>
              <h3>Admin Login</h3>
            </p>
            <div className="form-control">
              <input
                type="text"
                name="email"
                className="form-control"
                id="youremail"
                autoComplete="off"
                placeholder="Email"
                maxLength="100"
                value={email}
                onChange={handleEmailChange}
              />
              {emailError && <span className="text-danger">{emailError}</span>}
            </div>

            <div className="form-control ">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                id="password"
                className="form-control"
                placeholder="Password"
                maxLength="100"
                value={password}
                onChange={handlePasswordChange}
              />

              <span
                className="form-control eye-btn"
                id="toggle"
                onClick={togglePassword}
              >
                {showPassword ? (
                  <i className="ri-eye-line "></i>
                ) : (
                  <i className="ri-eye-off-line "></i>
                )}
              </span>

              {passError && <span className="text-danger">{passError}</span>}
            </div>

              <div className="form-control ">
                         
                {captchaKey && (
                             <ReCAPTCHA
                              ref={recaptchaRef}
                               sitekey={captchaKey}
                               onChange={(value) => setToken(value)}
                             />
                           )}
                
                  {captchaError && <span style={{ color: "red" }}>{captchaError}</span>}
                        </div>
                        

            <div className="login-form-group single-row">
              <div className="custom-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="rememberMe"
                  id="rememberMe"
                  checked={rememberMe}
                  onChange={handleRememberMeChange}
                />

                <label htmlFor="rememberMe">Remember me</label>
              </div>
            </div>
            {error && <span className="text-danger">{error}</span>}
            <button className="btn">Sign in</button>
          </form>
        </div>
      </section>
    </React.Fragment>
  );
}
export default injectModels(["application", "auth"])(AdminLogin);
